import { message } from 'antd';
import _ from 'lodash';

const parseJwt = (token: string) => {
  if (!token) {
    return false;
  }
  const base64Url = token.split('.')[1];
  const base64 = base64Url.replace('-', '+').replace('_', '/');
  return JSON.parse(window.atob(base64));
};

const convertToTwoDigitString = (integerToConvert: string | number) => {
  return integerToConvert.toString().padStart(2, '0');
};

const uuidv4 = () => {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    // eslint-disable-next-line no-bitwise
    const r = (Math.random() * 16) | 0;
    // eslint-disable-next-line no-bitwise
    const v = c === 'x' ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
};

const downloadFile = (url: string, fileName: string) => {
  const link = document.createElement('a');
  link.download = fileName;
  link.href = url;
  document.body.appendChild(link);
  link.setAttribute('download', fileName);
  link.click();
  document.body.removeChild(link);
  message.success('File download started...');
};

const formatDuration = (time: number) => {
  const hours = Math.floor(time / 3600);
  const minutes = Math.floor(time / 60);
  const seconds = Math.floor(time - minutes * 60);
  if (hours) {
    return `${hours.toString().padStart(2, '')}h ${minutes
      .toString()
      .padStart(2, '')}m ${seconds.toString().padStart(2, '')}s`;
  }
  if (minutes)
    return `${minutes.toString().padStart(2, '')}m ${seconds
      .toString()
      .padStart(2, '')}s`;
  return `${seconds.toString().padStart(2, '')}s`;
};

/**
 * Formats the number, in a presentable form.
 * formatting includes, decimal place filtering, etc.
 * @param {Number} value : to format out.
 */
const numFormatting = (value: number) => {
  let val = '';
  if (value) {
    let x: string = value.toString();
    let afterPoint = '';
    if (x.indexOf('.') > 0) afterPoint = x.substring(x.indexOf('.'), x.length);
    x = Math.floor(Number(x)).toString();
    let lastThree = x.substring(x.length - 3);
    const otherNumbers = x.substring(0, x.length - 3);
    if (otherNumbers !== '') lastThree = `,${lastThree}`;
    val =
      otherNumbers.replace(/\B(?=(\d{3})+(?!\d))/g, ',') +
      lastThree +
      afterPoint;
  } else {
    val = '0';
  }
  return val;
};

const validateEmail = (email: string) => {
  const exp =
    /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:.[a-zA-Z0-9-]+)*$/;
  return email.match(exp);
};

const substringAfterOccurance = (textStr: string, char: string): string => {
  const index = `${textStr}`.indexOf(`${char}`);
  return `${textStr}`.substring(index + 1);
};

const getBaseUrl = (isAPIBaseURLRequired = false) => {
  if (isAPIBaseURLRequired) return process.env.REACT_APP_API_BASE_URL;
  const accessToken: string = localStorage.getItem('access_token') as string;
  // eslint-disable-next-line no-param-reassign
  const parse = parseJwt(accessToken);
  const region = parse[`${process.env.REACT_APP_AUTH0_AUDIENCE}/region`];
  // TODO: Env variables cant be accessed using a variable in the "key" name.
  // So `process.env.REACT_APP_API_BASE_URL_${region}` does not work. This
  // seems like a quirk of dot env package and needs to be looked into. Below a work around.
  const regionUrlMap: any = {
    CANADA: process.env.REACT_APP_API_BASE_URL_CANADA,
    US: process.env.REACT_APP_API_BASE_URL_US,
  };
  const regionString = regionUrlMap[region];
  return regionString || process.env.REACT_APP_API_BASE_URL_US;
};

const changeIndexOfArray = (
  array: any[],
  fromIndex: number,
  toIndex: number,
) => {
  const tmp = array[fromIndex];
  const newarray = _.cloneDeep(array);
  newarray[fromIndex] = newarray[toIndex];
  newarray[toIndex] = tmp;
  return newarray;
};

/**
 * If the input string is a json converted into a string, return true else false
 * @param stringToCheck : possible stringified version of json
 * @returns Boolean
 */
const isStringJson = (stringToCheck: string) => {
  try {
    JSON.parse(stringToCheck);
  } catch (e) {
    return false;
  }
  return true;
};

export {
  getBaseUrl,
  parseJwt,
  convertToTwoDigitString,
  uuidv4,
  downloadFile,
  formatDuration,
  numFormatting,
  validateEmail,
  substringAfterOccurance,
  changeIndexOfArray,
  isStringJson,
};
